export enum ReactionContextType {
    CLESSON = 'clesson',
}

export enum ReactionType {
    STICKER = 'sticker',
    LIKE = 'like',
}

export interface StickerReactionPayload
{
    slug: string;
    course_id: number;
}

export interface LikeReactionPayload
{
    slug: string;
}

export interface Reaction<TPayload>
{
    id: string;
    context_id: string;
    context_type: ReactionContextType;
    payload: TPayload;
    sender_id: number;
    receiver_id: number;
    reaction_type: ReactionType;
    is_viewed: boolean;
}
